import {AddressSavePayload} from '../../../../../common/address/model/addressSave.payload';

export class ReportRecipientInputFormProperty {
    address: AddressSavePayload;
}
